module.exports = __webpack_public_path__ + "static/media/yumikoi.773c9e9d.svg";